<!-- 
	This is the tables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <CardProjectTable2
          :data="tableData"
          :columns="table2Columns"
          :locale="tableLocale"
          @fetchLinks="handleFetchLinks"
        ></CardProjectTable2>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { fetchLinks } from "@/api/index";

// "Projects" table component.
import CardProjectTable2 from "./components/CardProjectTable2";

// "Projects" table list of columns and their properties.
const table2Columns = [
  {
    title: "类型",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
    width: 300,
  },

  {
    title: "链接",
    scopedSlots: { customRender: "link" },
    dataIndex: "link",
  },
  {
    title: "",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

export default {
  components: {
    CardProjectTable2,
  },
  data() {
    return {
      // "Projects" 表列定义，与模板 :columns 绑定。
      table2Columns: table2Columns,
      tableData: [],
      // 由路由/上层传入的目标站点；管理端落地页未挂导航且无站点上下文时为空。
      website: (this.$route && this.$route.query && this.$route.query.website) || "",
    };
  },
  computed: {
    // 本地化空态，替换 ant 默认英文库存插画。
    tableLocale() {
      const h = this.$createElement;
      return {
        emptyText: () =>
          h("div", { class: "aeg-empty" }, [
            h("a-icon", { props: { type: "link" }, class: "aeg-empty-icon" }),
            h("p", { class: "aeg-empty-title" }, "暂无链接数据"),
            h(
              "p",
              { class: "aeg-empty-desc" },
              "本页需在指定站点上下文下查看；可点击右上角「添加链接」录入真实链接。"
            ),
          ]),
      };
    },
  },
  methods: {
    fetchMyLinks() {
      // 无站点上下文时不发请求，避免 GET /api/links 400（缺 website 参数）。
      if (!this.website) {
        this.tableData = [];
        return;
      }
      fetchLinks({ website: this.website })
        .then((res) => {
          const data = (res && res.data) || {};
          const fakeList = Array.isArray(data.fake) ? data.fake : [];
          const trueList = Array.isArray(data.true) ? data.true : [];
          const rows = [];
          if (fakeList.length) {
            rows.push({
              key: "fake-0",
              type: {
                name: "斗篷链接(供恶意用户访问)",
                logo: "images/fake.png",
              },
              link: fakeList[0],
              linkType: "fake",
            });
          }
          trueList.forEach((item, idx) => {
            rows.push({
              key: "true-" + idx,
              type: {
                name: "真实链接(供真实用户访问)",
                logo: "images/true.png",
              },
              link: item,
              linkType: "true",
            });
          });
          this.tableData = rows;
        })
        .catch((err) => {
          // 失败回落到本地化空态，不再向控制台抛 400。
          this.tableData = [];
          console.warn("[落地页] 拉取链接失败：", err);
        });
    },
    handleFetchLinks() {
      this.fetchMyLinks();
    },
  },
  mounted() {
    this.fetchMyLinks();
  },
};
</script>

<style lang="scss">
.aeg-empty { padding: 32px 16px; text-align: center; color: #8c8c8c; }
.aeg-empty-icon { font-size: 40px; color: #bfbfbf; margin-bottom: 12px; }
.aeg-empty-title { margin: 0 0 4px; font-size: 15px; font-weight: 600; color: #595959; }
.aeg-empty-desc { margin: 0; font-size: 13px; color: #8c8c8c; }
</style>